import React from 'react'
import './footer.scss'

function Footer() {
   return (
      <div className="footer">
         <div className="footer__social">
            <a
               href="https://github.com/newtfrank"
               className="footer__social--link">
               Github
            </a>
            <a
               href="https://twitter.com/mbugua_newton"
               className="footer__social--link">
               Twitter
            </a>
            <a
               href="https://www.instagram.com/_la_photon/"
               className="footer__social--link">
               Instagram
            </a>
            <a
               href="https://www.linkedin.com/in/newton-mbugua-8b3462ba/"
               className="footer__social--link">
               LinkedIn
            </a>
         </div>
         <div className="footer__copyright">
            <h5>&copy; 2020 newton.netlify.app</h5>
         </div>
      </div>
   )
}

export default Footer
